import {
  CONCIERGE_BASE_SCHEME_CSS,
  CONCIERGE_DARK_CANVAS_DERIVATION_CSS,
  CONCIERGE_LIGHT_CANVAS_DERIVATION_CSS,
  CONCIERGE_LIGHT_SCHEME_CSS,
  CONCIERGE_PRIMITIVES_CSS,
} from '@dutchie/common/utils/concierge-theme-css';

/**
 * Concierge CSS, re-scoped for the admin live preview pane.
 *
 * The declaration blocks are the same strings production interpolates
 * (@dutchie/common/utils/concierge-theme-css), so the browser computes the exact same
 * derived tokens (including every color-mix / relative-color formula) that
 * the storefront renders — only the scoping selectors differ:
 *
 *   :root                                              -> &&
 *   .concierge-mode (base, applies in both schemes)    -> &&
 *   .concierge-mode[data-concierge-theme="light"]      -> &&[data-scheme='light']
 *   darkCanvasBlock()                                  -> &&[data-scheme='dark'][data-has-canvas='true']
 *   lightCanvasBlock()                                 -> &&[data-scheme='light'][data-has-canvas='true']
 *
 * `--dcm-concierge-canvas` and the tenant accent are set inline via `style`
 * on the preview root — inline custom properties win the cascade on that
 * element, so the accent-derived tokens (accent family, effect chips,
 * strain dots) recompute exactly as production's tenant override does.
 *
 * The canvas derivations are scheme-gated here (production only ever emits
 * one of the two blocks; the preview carries both and lets the data-scheme
 * attribute pick). A few base declarations reference marketplace globals
 * that don't exist in Admin (skeleton shimmer sources, header divider) —
 * they're inert because the preview markup doesn't render those pieces.
 */
export const CONCIERGE_PREVIEW_CSS = `
  && {
${CONCIERGE_PRIMITIVES_CSS}
${CONCIERGE_BASE_SCHEME_CSS}
  }

  &&[data-scheme='light'] {
${CONCIERGE_LIGHT_SCHEME_CSS}
  }

  &&[data-scheme='dark'][data-has-canvas='true'] {
${CONCIERGE_DARK_CANVAS_DERIVATION_CSS}
  }

  &&[data-scheme='light'][data-has-canvas='true'] {
${CONCIERGE_LIGHT_CANVAS_DERIVATION_CSS}
  }
`;
